export const stateSyntax = CSS.supports("selector(:state(checked))");
